const team = [
  {
    name: "Denise Pomboonreung",
    title: "CEO",
    description:
      "Sets the vision for the agency, leads client relationships, and drives long-term growth with a service-first mindset.",
    img: require("../../assets/team/MS DENISE.png"),
  },
  {
    name: "Andy Zubia",
    title: "President",
    description:
      "Oversees company strategy and daily execution, keeping the team aligned and the client experience consistent.",
    img: require("../../assets/team/SIR ANDY.png"),
  },
  {
    name: "Donna Jumdail",
    title: "Operations Lead",
    description:
      "Manages workflow, coordination, and service follow-through so every request moves smoothly from start to finish.",
    img: require("../../assets/team/DONNA.png"),
  },
];

export default function TeamSection() {
  return (
    <section className="bg-white-pure w-full py-24 px-6 relative overflow-hidden">
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          backgroundImage:
            "repeating-linear-gradient(90deg, rgba(1,46,114,0.03) 0px, rgba(1,46,114,0.03) 1px, transparent 1px, transparent 80px)",
        }}
      />

      <div className="max-w-5xl mx-auto relative">
        {/* Section header */}
        <div className="flex flex-col items-center gap-4 mb-16 text-center">
          <div className="flex items-center gap-3">
            <div className="w-1 h-4 bg-blue-dark rounded-full opacity-60" />
            <span
              className="font-cinzel text-blue-dark uppercase tracking-widest"
              style={{ fontSize: "11px", letterSpacing: "0.2em" }}
            >
              Leadership Team
            </span>
            <div className="w-1 h-4 bg-blue-dark rounded-full opacity-60" />
          </div>

          <h2
            className="font-cinzel font-bold text-blue-dark uppercase"
            style={{ fontSize: "clamp(24px, 4vw, 40px)", letterSpacing: "0.04em", lineHeight: "1.15" }}
          >
            Meet the Team
          </h2>

          <div className="flex items-center gap-3">
            <div className="h-px w-12 bg-blue-dark opacity-20" />
            <div className="w-1.5 h-1.5 rounded-full bg-blue-dark opacity-30" />
            <div className="h-px w-12 bg-blue-dark opacity-20" />
          </div>

          <p
            className="font-constantia text-black-deep max-w-xl leading-relaxed"
            style={{ fontSize: "16px", opacity: 0.6 }}
          >
            Dedicated professionals committed to providing what matters most to you.
          </p>
        </div>

        {/* Team cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {team.map(({ name, title, description, img }) => (
            <div key={name} className="flex flex-col gap-5 group">
              {/* Photo */}
              <div className="w-full rounded-xl overflow-hidden relative" style={{ aspectRatio: "3/4" }}>
                <img
                  src={img}
                  alt={name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-blue-dark/30 to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 h-1 bg-blue-primary opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              </div>

              {/* Info */}
              <div className="flex flex-col gap-2">
                <div className="flex items-center gap-2">
                  <div className="h-px flex-1 bg-blue-dark opacity-10" />
                </div>
                <h3
                  className="font-cinzel font-bold text-blue-dark uppercase"
                  style={{ fontSize: "13px", letterSpacing: "0.1em" }}
                >
                  {name}
                </h3>
                <span
                  className="font-constantia text-blue-primary"
                  style={{ fontSize: "12px", opacity: 0.7, letterSpacing: "0.08em", textTransform: "uppercase" }}
                >
                  {title}
                </span>
                <p
                  className="font-constantia text-black-deep leading-relaxed"
                  style={{ fontSize: "14px", opacity: 0.6 }}
                >
                  {description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
